(() => {
  const config = document.getElementById('bb-engraving-validation')
  if (!config) return
  const main = document.getElementById('MainContent')
  const errors = new Map()
  let nextId = 0

  function clear(field) {
    const error = errors.get(field)
    if (!error) return
    error.node.remove()
    field.removeAttribute('aria-invalid')
    if (error.describedBy) field.setAttribute('aria-describedby', error.describedBy)
    else field.removeAttribute('aria-describedby')
    errors.delete(field)
  }

  function visible(field) {
    return !field.disabled && !!field.getClientRects().length
      && !field.closest('[hidden], .apo-hidden-by-cl')
  }

  function complete(field) {
    if (field.type !== 'file') return !!field.value.trim()
    const uploaded = field.closest('.avp-option')?.querySelector('input.apo_value')
    return !!field.files?.length || !!uploaded?.value.trim()
  }

  function validate(form) {
    if (!form || !main?.contains(form)) return true
    const primary = main.querySelector('input[name="properties[_apo_options]"]')?.form
      || main.querySelector('form[action*="/cart/add"]')
    const roots = [...main.querySelectorAll('.avpoptions-container__v2')].filter(node => {
      const engine = node.__apoEngine
      return (engine?.mainProductForm || engine?.productForm || primary) === form
    })
    let first = null
    for (const [field] of errors) {
      if (!field.isConnected || !visible(field) || complete(field)) clear(field)
    }
    for (const root of roots) {
      for (const field of root.querySelectorAll('textarea, input[type="text"], input[type="file"]')) {
        const name = field.getAttribute('field-name') || field.name || ''
        if (!/(engrav|etch)/i.test(name) || !visible(field)) continue
        if (field.type !== 'file' && !/(instructions|text)/i.test(name)) continue
        if (complete(field)) continue
        if (errors.has(field) && !errors.get(field).node.isConnected) clear(field)
        if (!errors.has(field)) {
          const node = document.createElement('p')
          node.id = 'bb-engraving-error-' + ++nextId
          node.className = 'bb-engraving-error'
          node.setAttribute('role', 'alert')
          node.textContent = field.type === 'file' ? config.dataset.fileRequired : config.dataset.textRequired
          const describedBy = field.getAttribute('aria-describedby')
          errors.set(field, { node, describedBy })
          field.setAttribute('aria-describedby', [describedBy, node.id].filter(Boolean).join(' '))
          field.closest('.avp-option').append(node)
        }
        const error = errors.get(field)
        field.setAttribute('aria-invalid', 'true')
        field.setAttribute('aria-describedby', [error.describedBy, error.node.id].filter(Boolean).join(' '))
        first ||= field
      }
    }
    if (!first) return true
    first.closest('.avp-option').scrollIntoView({ block: 'center', behavior: 'smooth' })
    first.focus({ preventScroll: true })
    return false
  }

  function guard(event) {
    const trigger = event.target.closest?.('button[name="add"], button[type="submit"], input[type="submit"]')
    const form = event.type === 'submit' ? event.target : trigger?.form
    if (!form?.matches('form[action*="/cart/add"]') || validate(form)) return
    event.preventDefault()
    event.stopImmediatePropagation()
  }

  window.BBEngraving = { validate }
  window.addEventListener('click', guard, true)
  window.addEventListener('submit', guard, true)
  for (const type of ['input', 'change']) {
    document.addEventListener(type, () => {
      for (const [field] of errors) {
        if (!field.isConnected || !visible(field) || complete(field)) clear(field)
      }
    })
  }
})()
